import {
    Component, EventEmitter, Input, OnInit, Output,
    TemplateRef,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { OverlayContext } from 'ngx-modialog';
import { ClientModel } from '../../../../../shared/models/client.model';
import { SubscriptionModel } from '../../../../../shared/models/subscription.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommonHttpService } from '../../../../../shared/services/http.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'account-subscriptions-details-actions-cancel',
    templateUrl: './account.subscriptions.details.actions.cancel.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsCancelComponent implements OnInit {
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;
    @Input('client') client: ClientModel;
    @Input('subscription') subscription: SubscriptionModel;
    @Output('loading') loading: EventEmitter<null> = new EventEmitter();
    @Output('updated') updated: EventEmitter<null> = new EventEmitter();
    @Output('failed') failed: EventEmitter<null> = new EventEmitter();

    public reason: FormControl;
    protected overlayContext = new OverlayContext();
    private cancelForm: FormGroup;

    constructor(
        protected modal: Modal,
        protected http: CommonHttpService,
        protected translate: TranslateService,
        protected toastr: ToastrService
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;
    }

    ngOnInit() {
        this.reason = new FormControl('', [
            Validators.required,
            Validators.min(1),
            Validators.max(200)
        ]);
        this.cancelForm = new FormGroup({
            reason: this.reason
        });
    }

    /**
     * Open cancel dialog to input cancel reason.
     **/
    public openCancelDialog() {
        this.modal
            .open(this.templateRef, {context: this.overlayContext})
            .then();
    }

    /**
     * Validate and call API to request subscription cancel.
     **/
    public cancel() {
        if (!this.cancelForm.valid) {
            this.translate
                .get('ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.CANCEL_MODAL.VALIDATION_ERROR')
                .subscribe(message => this.toastr.error(message));
            return;
        }

        this.loading.emit();
        this.triggerCancel();
    }

    /**
     * Call API to request cancel.
     **/
    private triggerCancel() {
        this.translate.get([
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.CANCEL_MODAL.SUCCESS',
            'ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.CANCEL_MODAL.ERROR'
        ]).subscribe(translated => {
            this.http.useAuth().post(
                `/account/clients/${this.client.id}`
                + `/subscriptions/${this.subscription.id}`
                + `/cancel`,
                {
                    reason: this.reason.value
                }
            )
            .subscribe(() => {
                this.updated.emit();
                this.toastr.success(translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.CANCEL_MODAL.SUCCESS']);
                this.modal.overlay.closeAll();
            }, () => {
                this.failed.emit();
                this.toastr.error(translated['ACCOUNT.SUBSCRIPTIONS.DETAILS.BASIC_DATA.CANCEL_MODAL.ERROR']);
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/subscriptions/details/actions/cancel/account.subscriptions.details.actions.cancel.component.ts